// @flow

import React, { type Node } from 'react';
import styled from 'styled-components';

import { Separator } from '../../atoms';

import ebanxDarkBlueSrc from './ebanx-logo-darkblue.svg';
import padlockNewSrc from './padlock-new.svg';

import { MainPanelHeader } from '../../template';
import { translate } from '@tectonics/translate';
import { theme } from '@tectonics/look-and-feel/uber-v2/theme';

export function Header(): Node {
  return (
    <MainPanelHeader>
      <ContentWrapper>
        <DefaultContent />
      </ContentWrapper>
    </MainPanelHeader>
  );
}

function DefaultContent(): Node {
  return (
    <>
      <Separator direction="horizontal" size={4} />
      <PayingByMessage />
      <HeaderContent />
      <Separator direction="horizontal" size={4} />
    </>
  );
}

function PayingByMessage(): Node {
  return <>{translate('volcanes.payingByMessage')}</>;
}

function SafePageMessage(): Node {
  return translate('volcanes.safePaymentPage');
}

function HeaderContent(): Node {
  return <DefaultHeaderContent />;
}

function DefaultHeaderContent(): Node {
  return (<>
    <PayingBy>
      <EbanxLogo src={ebanxDarkBlueSrc} alt="ebanx" />
    </PayingBy>
    <SecurePageSpan>
      <MobileHidden>
        <SafePageMessage />
      </MobileHidden>
    </SecurePageSpan>
  </>);
}

const ContentWrapper = styled.div`
  height: 64px;
  display: flex;
  align-items: center;
`;

const PayingBy = styled.span`
  flex-grow: 1;
`;

const EbanxLogo = styled.img`
  height: 0.8em;
  max-width: 100%;
  margin: auto;
  display: block;
  margin-left: 6px;
`;

const SecurePageSpan = styled.span`
  color: ${theme.colors.new_primary[700]};
  &:before {
    content: '';
    padding: 0.5em;
    margin-right: 0.3em;
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    background-image: url(${padlockNewSrc});
  }
`;

const MobileHidden = styled.span`
  @media (max-width: 840px) {
    display: none;
  }
`;
